import React from 'react';
import { Link } from 'react-router-dom';


function Footer() {
    return (
        <div className='bg-colourBg'>
            <div className='text-white px-4 sm:px-6 md:px-8 mid-lg:px-16 lg:px-24'>
                {/* White line at the start */}
                <div className='py-12 sm:py-16'>
                    <h1 className='text-base sm:text-lg md:text-xl font-light tracking-wider'>
                        START YOUR JOURNEY WITH HAIDERIES
                    </h1>
                    <div className='flex flex-col sm:flex-row gap-3 sm:gap-4 mt-6'>
                        <Link to="/" className="w-full sm:w-auto">
                            <button className='w-full sm:w-auto text-black bg-white rounded px-8 sm:px-12 py-3 border border-white tracking-widest font-semibold hover:text-white hover:bg-transparent transition-colors text-xs sm:text-sm'>
                                FIND PROPERTY
                            </button>
                        </Link>
                        <Link to='/ListProperty' className="w-full sm:w-auto">
                            <button className='w-full sm:w-auto text-white bg-transparent rounded px-8 sm:px-12 py-3 border border-white tracking-widest font-semibold hover:text-black hover:bg-white transition-colors text-xs sm:text-sm'>
                                LIST PROPERTY
                            </button>
                        </Link>
                    </div>
                </div>
                <div className="border-t border-white/20 mb-4"></div>

                {/* Footer content with grid */}
                <div className='text-xs text-colourFt py-10 sm:py-12 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6 sm:gap-8'>
                    {/* Column 1 */}
                    <div className='mb-4'>
                        <h2 className='text-sm text-white font-semibold mb-4'>BUY PROPERTY</h2>
                        <ul className='list-none space-y-2'>
                            <li className='hover:text-white transition-colors'><Link to='/ComingSoon'>Properties for sale</Link></li>
                            <li className='hover:text-white transition-colors'><Link to='/BuyWithHaideries'>Buying with Haideries</Link></li>
                            <li className='hover:text-white transition-colors'><Link to='/BuyersGuide'>Buyers Guide</Link></li>
                        </ul>
                    </div>

                    {/* Column 2 */}
                    <div className='mb-4'>
                        <h2 className='text-sm text-white font-semibold mb-4'>SELL PROPERTY</h2>
                        <ul className='list-none space-y-2'>
                            <li className='hover:text-white transition-colors'><Link to='/BookValuation'>Book a valuation</Link></li>
                            <li className='hover:text-white transition-colors'><Link to='/ListProperty'>List your Property</Link></li>
                            <li className='hover:text-white transition-colors'><Link to='/SellYourProperty'>Sell with Haideries</Link></li>
                            <li className='hover:text-white transition-colors'><Link to='/SellersGuide'>Seller Guide</Link></li>
                        </ul>
                    </div>

                    {/* Column 3 */}
                    <div className='mb-4'>
                        <h2 className='text-sm text-white font-semibold mb-4'>RENT PROPERTY</h2>
                        <ul className='list-none space-y-2'>
                            <li className='hover:text-white transition-colors'><Link to='/ComingSoon'>Properties for rent</Link></li>
                            <li className='hover:text-white transition-colors'><Link to='/RentWithHaideries'>Why rent with Haideries</Link></li>
                            <li className='hover:text-white transition-colors'><Link to='/TenantsGuide'>Tenants Guide</Link></li>
                        </ul>
                    </div>

                    {/* Column 4 */}
                    <div className='mb-4'>
                        <h2 className='text-sm text-white font-semibold mb-4'>ABOUT</h2>
                        <ul className='list-none space-y-2'>
                            <li className='hover:text-white transition-colors'><Link to='/WhyHaideries'>Why Haideries</Link></li>
                            <li className='hover:text-white transition-colors'><Link to='/RoadShows'>International Roadshows</Link></li>
                        </ul>
                    </div>

                    {/* Column 5 */}
                    <div className='mb-4 col-span-2 sm:col-span-1'>
                        <h2 className='text-sm text-white font-semibold mb-4'>CONTACT</h2>
                        <ul className='list-none space-y-2'>
                            <li className='hover:text-white transition-colors'><Link to='/Contact'>General Enquiry</Link></li>
                            <li className='hover:text-white transition-colors'><Link to='/TermsAndConditions'>Terms and Conditions</Link></li>
                            <li className='hover:text-white transition-colors'><Link to='/PrivacyPolicy'>Privacy Policy</Link></li>
                            <li className='hover:text-white transition-colors'><Link to='/CookiePolicy'>Cookie Policy</Link></li>
                        </ul>
                    </div>
                </div>

                {/* White line at the end */}
                <div className="border-b border-white/20 mt-4"></div>
                <div className='text-xs text-gray-400 py-8 pb-24 sm:pb-12 space-y-1.5'>
                    <p className='text-base sm:text-lg font-semibold text-white'>Haideries Real Estate</p>
                    <p>4th Floor, Bay Square, Dubai, UAE</p>
                    <p>
                        <span>Phone: </span>
                        <a href='tel:+971542999975' className='hover:text-white text-gray-300 transition-colors'>
                            +971 54 299 9975
                        </a>
                    </p>
                    <p className='pt-2 text-gray-500'>© 2024 Haideries Real Estate. All Rights Reserved.</p>
                </div>
            </div>
        </div>
    );
}

export default Footer;
